import React from 'react'
import { EllipsisOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import SubmoduleDel from './SubmoduleDel';
import InterfaceAdd from '../interface/InterfaceAdd';
import SubmoduleEdit from './SubmoduleEdit';

function SubModuleDropdown(props) {
    const items = [
        {
            label: (
                <SubmoduleEdit 
                    bgn_id={props.bgn_id}                                                     
                    bgn_name={props.bgn_name} 
                    bg_id={props.bg_id}
                    bg_name={props.bg_name}
                    bg_dept_id={props.bg_dept_id}
                    bg_dept_name={props.bg_dept_name}
                    bbb_id={props.bbb_id}
                    bbb_name={props.bbb_name}
                />
            ),
            key: 'ModuleEdit',
        },
        {
            label: (
                <SubmoduleDel bbb_id={props.bbb_id}/>
            ),
            key: 'ModuleDel',
        },      
        {
            type: 'divider',
        }, 
        {
            label: (
                <InterfaceAdd
                    bgn_id={props.bgn_id}                                                     
                    bgn_name={props.bgn_name} 
                    bg_id={props.bg_id}
                    bg_name={props.bg_name}
                    bg_dept_id={props.bg_dept_id}
                    bg_dept_name={props.bg_dept_name}
                    bbb_id={props.bbb_id}
                    bbb_name={props.bbb_name}
                />
            ),
            key: 'SubmoduleAdd',
        }, 
    ];
    return (
        <Dropdown menu={{ items }} trigger={['click']}>
            <a onClick={e => e.preventDefault()}> <EllipsisOutlined /></a>
        </Dropdown>
    )
}

export default SubModuleDropdown